<script lang="ts" setup>
    import { useRoute } from 'vue-router';
    import { useMenuStore } from '@/stores/menu';
    import { useTheme } from 'vuetify';
    import { computed } from 'vue';
    import { useUserStore } from '@/stores/user';
    import { getPlatform } from '@/helpers/getPlatform';
    import { Platform } from '@/constants';

    const route = useRoute();
    const menuStore = useMenuStore();
    const userStore = useUserStore();

    const opened = ref<string[]>([]);
    const theme = useTheme();
    const { t } = useI18n();

    const navMenuItems = computed(() => {
        if (userStore.isLoggedIn() && getPlatform() === Platform.Tradeball) {
            return menuStore.getNavMenuItems;
        } else if (userStore.isLoggedIn() && getPlatform() !== Platform.Tradeball) {
            return menuStore.getNavMenuItemsWL;
        }

        return menuStore.getNavMenuItemsGuest;
    });

    watch(
        () => route.name,
        () => {
            if (route.meta.menu) {
                opened.value.push(route.meta.menu as string);
            } else {
                opened.value = [];
            }
        },
        { immediate: true }
    );

    onMounted((): void => {
        console.log('Component app-menuMobile mounted.');
    });
</script>
<template>
    <v-navigation-drawer tag="nav" fixed temporary v-model="menuStore.mobileMenuDrawer">
        <v-list nav density="compact" variant="flat" class="mobile" open-strategy="list" :opened="opened">
            <div v-for="(item, i) in navMenuItems" :key="i">
                <v-list-item
                    density="compact"
                    v-if="!item.subItems"
                    :to="item.link"
                    class="pl-10"
                    :class="[item.link === route.name ? 'v-item--active v-list-item--active' : '']"
                    style="height: 32px !important"
                >
                    <v-list-item-title
                        class="font-weight-medium pt-2"
                        style="line-height: 2rem; min-height: 32px !important"
                        :class="[item.link === route.name ? 'tbgreen-text' : theme.name.value === 'dark' ? 'whiteText' : 'blackText']"
                    >
                        {{ t('menu.' + item.title) }}
                    </v-list-item-title>
                </v-list-item>
                <v-list-group class="m-menu" v-else :value="item.title">
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            v-bind="props"
                            class="font-weight-medium pt-1 px-2 m-menu"
                            style="line-height: 2rem; min-height: 32px !important"
                            :class="[item.title === route.meta.menu && route.name !== 'bot' ? 'tbgreen-text' : theme.name.value === 'dark' ? 'whiteText' : 'blackText']"
                            :title="t('menu.' + item.title)"
                        >
                            <template v-slot:prepend>
                                <v-icon class="pb-1" :style="item.title === route.meta.menu ? 'opacity: 1' : ''">{{ item.icon }}</v-icon>
                            </template>
                            <!--                            <v-icon-->
                            <!--                                :color="-->
                            <!--                                    item.title === $route.meta.menu && $route.name !== 'bot' ? 'tbGreen' : '#7a7a7a'-->
                            <!--                                "-->
                            <!--                                style="margin-right: 10px"-->
                            <!--                                size="24"-->
                            <!--                            >{{ item.icon }}-->
                            <!--                            </v-icon-->
                            <!--                            >-->
                            <!--                            {{  }}-->
                        </v-list-item>
                    </template>

                    <!--                    <div :key="item.title" >-->
                    <v-list v-if="item.subItems" class="py-0 rounded">
                        <div v-for="subItem in item.subItems" :key="subItem.title" class="pb-1" :style="!subItem.link ? 'height: 34px' : 'height: 40px'">
                            <v-list-subheader
                                v-if="!subItem.link"
                                :class="theme.name.value === 'dark' ? '' : 'blackText'"
                                class="pl-16 font-weight-black font11 text-uppercase"
                                style="min-height: 30px !important"
                            >
                                {{ t('menu.' + subItem.title) }}
                            </v-list-subheader>
                            <router-link
                                v-else
                                :to="{
                                    name: subItem.link,
                                    params: subItem.params ? subItem.params : {},
                                }"
                                style="height: 36px"
                            >
                                <v-list-item
                                    nav
                                    density="compact"
                                    variant="flat"
                                    style="min-height: 32px; padding-left: 40px !important; padding-bottom: 0; padding-top: 2px"
                                    :class="[subItem.link === route.name ? 'v-item--active v-list-item--active' : '']"
                                >
                                    <!--                                        <v-list-item-content>-->
                                    <v-list-item-title
                                        class="font-weight-medium"
                                        :class="[subItem.link === route.name ? 'tbgreen-text' : theme.name.value === 'dark' ? 'whiteText' : 'blackText']"
                                        style="line-height: 2rem"
                                    >
                                        <v-icon v-if="subItem.icon" :color="subItem.iconColor" size="20">
                                            {{ subItem.icon }}
                                        </v-icon>
                                        {{ t('menu.' + subItem.title) }}
                                    </v-list-item-title>
                                    <!--                                        </v-list-item-content>-->
                                </v-list-item>
                            </router-link>
                            <v-divider v-if="subItem.divider" class="mt-1 ml-11"></v-divider>
                        </div>
                    </v-list>
                    <!--                    </div>-->
                </v-list-group>
            </div>
        </v-list>
    </v-navigation-drawer>
</template>
<style scoped>
    .m-menu :deep(.v-list-item__prepend) {
        width: 33px !important;
    }

    .m-menu :deep(.v-list-item__append .v-icon) {
        color: #7a7a7a;
    }

    .v-list--density-compact .v-list-subheader {
        padding-inline-start: calc(42px + var(--indent-padding)) !important;
    }

    .v-list-item--nav.v-item--active.v-list-item--active {
        background-color: #f5f5f5;
    }

    .v-theme--dark .v-list-item--nav.v-item--active.v-list-item--active {
        background-color: #37383b;
    }

    .v-theme--dark .v-list--nav {
        background-color: #2b2d31 !important;
    }

    .v-theme--dark .v-list-item--variant-flat {
        background-color: #2b2d31;
    }

    .v-theme--dark .v-icon {
        color: #b5bac1;
    }

    :deep(.v-list-item .v-list-item__prepend .v-icon) {
        font-size: 24px !important;
    }

    :deep(.v-list-item .v-list-item__content) {
        padding-bottom: 4px;
        padding-left: 3px;
    }

    .v-theme--dark :deep(.v-icon) {
        color: #b5bac1;
        opacity: 1;
    }

    .v-theme--dark.v-subheader {
        color: rgba(255, 255, 255, 0.7);
    }
</style>
